import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a92c5116d471300140f0d09_1788615056433_7a11f392/chatnova/src/app/page.tsx");
